import { palette } from '../../styles/tokens';

export type BookingTab = 'upcoming' | 'past';

export const BOOKING_TABS: { key: BookingTab; label: string }[] = [
  { key: 'upcoming', label: 'Upcoming' },
  { key: 'past', label: 'Past' },
];

export const BOOKING_STATUSES: Record<string, { label: string; bg: string; fg: string }> = {
  pending: { label: 'Pending', bg: palette.g100, fg: palette.g500 },
  confirmed: { label: 'Confirmed', bg: palette.blueWash, fg: palette.blue },
  in_progress: { label: 'In Progress', bg: '#FFF7ED', fg: '#CA5010' },
  completed: { label: 'Completed', bg: palette.greenWash, fg: palette.green },
  cancelled: { label: 'Cancelled', bg: palette.redWash, fg: palette.red },
  no_show: { label: 'No Show', bg: palette.redWash, fg: palette.red },
};

export const PAYMENT_STATUSES: Record<string, { label: string; bg: string; fg: string }> = {
  unpaid: { label: 'Unpaid', bg: palette.g100, fg: palette.g500 },
  prepaid: { label: 'Prepaid', bg: palette.greenWash, fg: palette.green },
  paid_cash: { label: 'Cash', bg: palette.greenWash, fg: palette.green },
  paid_card: { label: 'Card', bg: palette.greenWash, fg: palette.green },
  paid_etransfer: { label: 'E-Transfer', bg: palette.greenWash, fg: palette.green },
  closed_unpaid: { label: 'Closed (no payment)', bg: palette.g100, fg: palette.g400 },
};

export const SOURCES = [
  { value: 'phone', label: 'Phone' },
  { value: 'walk_in', label: 'Walk-in' },
  { value: 'app', label: 'App' },
  { value: 'booking_page', label: 'Booking Page' },
  { value: 'admin_panel', label: 'Admin Panel' },
];

export const STATUS_FLOW = ['pending', 'confirmed', 'in_progress', 'completed'];

export const TH: React.CSSProperties = {
  fontSize: 11, fontWeight: 600, color: palette.g400, textTransform: 'uppercase',
  letterSpacing: '0.06em', padding: '10px 12px', textAlign: 'left',
  borderBottom: `1px solid ${palette.g150}`, whiteSpace: 'nowrap',
};
export const TD: React.CSSProperties = {
  fontSize: 13, color: palette.g700, padding: '10px 12px',
  borderBottom: `1px solid ${palette.g100}`, whiteSpace: 'nowrap',
};
export const LABEL: React.CSSProperties = {
  fontSize: 13, fontWeight: 500, color: palette.g500, marginBottom: 4, display: 'block',
};
export const INPUT: React.CSSProperties = {
  width: '100%', padding: '9px 12px', borderRadius: 8,
  border: `1px solid ${palette.g200}`, fontSize: 13.5, color: palette.g800,
  fontFamily: 'inherit', outline: 'none', boxSizing: 'border-box' as const,
};
